import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_rpalgo.png",
      alt: "Estratégias RPAlgo",
    },
    title: "Lucre com nossos robôs.",

    // String ou array de strings
    text: "A RPAlgo acredita que investir é para todos, por isso cria soluções que cabem no bolso e permitem que independentemente do grau de conhecimento ou do valor investido você tenha rentabilidade sobre o capital.",

    testimonial: {
      text: "Sempre busquei criar algo que me trouxesse lucro no mercado, não vejo problema em compartilhar algo que me trouxe liberdade.",
      author: {
        name: "Thiago Pasa – Criador de estratégias RPAlgo",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias RPAlgo",
    heading: "Conheça nossas estratégias!",
    subtitle:
      "Veja as nossas estratégias prontas para uso. Comece com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão RPAlgo.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "RPAlgo",
    col1: [
      "A RPAlgo é uma empresa que cresceu muito rápido pelo reconhecimento de suas estratégias. Criada a 2 anos conta com mais de 1300 assinantes de suas estratégias, prestígio que veio através da qualidade e consistência dos robôs, que geram lucro e trazem segurança ao usuário. Quando se pensa em rentabilizar capital não podemos contar com sorte ou apostar, por isso a estabilidade e confiabilidade das estratégias é nossa maior preocupação. Você e seu capital em primeiro lugar.",
    ],
    // col2: [
    //   "",
    // ],
  },

  stats: {
    title: "Algumas conquistas da RPAlgo",
    subtitle: "Com 2 anos trouxe resultados de sucesso.",
    data: [
      {
        value: "+1.3k",
        description: "clientes ativos",
      },
      {
        value: "+20",
        description: "estratégias ativas",
      },
      {
        value: "+6",
        description: "anos no mercado",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da RPAlgo?",
    subtitle: "Veja quais as principais vantagens dos robôs da RPAlgo.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar milhares de cáculos por segundo e tomam decisões muito mais rápido do que qualquer ser humano.",
      },
      {
        icon: iconsSet.code,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a RPAlgo opere por você.",
      },
      {
        icon: iconsSet.lock_line,
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com a RPAlgo você não terá esse problema!",
      },
      {
        icon: iconsSet.growth,
        title: "Tenha consistência",
        description:
          "Sem a influência emocional, você executará suas estratégias de investimentos exatamente como foram programadas.",
      },
      {
        icon: iconsSet.clock,
        title: "Diversifique",
        description:
          "Realize operações em diferentes mercados e ativos, simultaneamente.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Gerencie melhor os riscos",
        description:
          "Configure objetivos de ganho e limites de perda em suas estratégias e tenha um melhor gerenciamento de riscos.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Os robôs me trouxeram liberdade que estava buscando, opera sozinho e traz lucros constantes.",
      author: "Roberto Alceu",
      job: "Jornalista",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Alcancei um rendimento muito melhor do que encontro por ai no mercado ou bancos.",
      author: "Julia Veroneze",
      job: "Médica",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão RPAlgo",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
